'use strict';
const _ = require('lodash');

const initialState = {
  showMobileMenu: true,
};

module.exports = (state = initialState, action) => {
  switch (action.type) {
    case 'MOBILE_MENU_TOGGLE':
      return {
        showMobileMenu: !(state.showMobileMenu),
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/header.js